import React from "react";

const AgreementSection = ({title, children}) =>
{
    const sectionHeaderStyle = {color: 'var(--s360-icon-blue)'}

    return (
        <div className='agreement-section'>
            <h3 style={sectionHeaderStyle}>{title}</h3>
            <div style={{padding: '10px'}}>
                {children}
            </div>
        </div>
    )
}

export default AgreementSection;